import { GET_AGENTSs } from "../../Actions/ActionConstants";

function AgentssReducer(state = null, action) {
    switch (action.type) {
        case GET_AGENTSs:
            if (action.data) { return action.data; }
            else { return state }
        default:
            return state;
    }
}
export default AgentssReducer